<template>
  <div class="body">
    <div class="body_center" v-loading="loading">
      <div class="body_center_left">
        <div class="body_center_left_friend">
          <div class="top_img"><img src="@/assets/imgs/header_bg1.png" /></div>
          <div class="friends_titbj">
            <div class="user_img"><img :src="userInfo.avatar"/></div>
            <div class="user_name">{{userInfo.nickname}}</div>
            <div class="user_msg">简介：{{userInfo.sign}}</div>
            <div class="user_menu">
              <div class="item">
                <div class="title">二ユース</div>
                <div class="msg">{{num.trackCount}}</div>
              </div>
              <div class="item">
                <div class="title">人気度</div>
                <div class="msg">{{num.charmNum}}</div>
              </div>
              <div class="item">
                <div class="title">フォロー中</div>
                <div class="msg">{{num.followNum}}</div>
              </div>
              <div class="item">
                <div class="title">フォロワー</div>
                <div class="msg">{{num.followerNum}}</div>
              </div>
            </div>
            <div class="user_attention" v-if="!userInfo.follow" @click="followFun()">
              フォローする
            </div>
            <div class="user_attention" v-else @click="followFun()">
              取消
            </div>
            <div class="user_letter" @click="chatFun()">
              私信
            </div>
          </div>
        </div>
        <div class="body_center_left_top">
          <div class="body_center_left_top_list">
            <div class="body_center_left_top_item" v-bind:class="{on_click:friendState==0}" @click="stateClickFun(0)">全て</div>
            <div class="body_center_left_top_item" v-bind:class="{on_click:friendState==1}" @click="stateClickFun(1)">記事</div>
            <div class="body_center_left_top_item" v-bind:class="{on_click:friendState==2}" @click="stateClickFun(2)">動画</div>
            <div class="body_center_left_top_item" v-bind:class="{on_click:friendState==3}" @click="stateClickFun(3)">凳見</div>
          </div>
          <!-- <div class="body_center_left_top_input">
            <input placeholder="关键词输入" />
            <img src="@/assets/imgs/search_article.png" />
          </div> -->
        </div>
        <div class="body_center_left_content">
          <div v-for="(item,index) in list" :key="index">
            <div class="body_center_left_content_article1" v-if="!item.images" @click="toArticleFun(item)">
              <!-- <img src="item.images[0]" /> -->
              <div class="title">{{item.content}}</div>
              <div class="msg_time"><span>{{item.creator.nickname}}</span><span class="time">{{timeToStr(item.createdDate)}}</span></div>
            </div>
            <div class="body_center_left_content_article1" v-else-if="!item.ad&&item.images.length<=1" @click="toArticleFun(item)">
              <img :src="item.images[0]" />
              <img class="play" v-if="item.videoUrl" src="@/assets/imgs/play.png" />
              <div class="title">{{item.title||item.content}}</div>
              <div class="msg_time"><span>{{item.creator.nickname}}</span><span class="time">{{timeToStr(item.createdDate)}}</span></div>
            </div>
            <div class="body_center_left_content_article2" v-else-if="!item.ad&&item.images.length>1">
              <div class="title">{{item.title}}</div>
              <div class="img_list">
                <img :src="items" v-for="(items, indexs) in item.images" :key="indexs" />
              </div>
              <div class="msg_time"><span>邦人NAVI</span><span class="time">2022-12-10</span></div>
            </div>
            <div class="body_center_left_content_ad" v-else-if="item.ad">
              <div class="title">{{item.title}}</div>
              <div class="img_list">
                <img :src="item.images[0]" />
              </div>
              <div class="msg_time"><div class="ad_icon">広告</div><span>{{item.creator.nickname}}</span><span class="time">{{timeToStr(item.createdDate)}}</span></div>
            </div>
          </div>
          <!-- <div class="body_center_left_content_article1">
            <img src="@/assets/imgs/header_bg1.png" />
            <div class="title">科学的な慎重さと歪みの積極的な最適化と改善科学的な慎重さと科学的な慎重さと歪みの積極的な最適化と改善科</div>
            <div class="msg_time"><div class="img"><img src="@/assets/imgs/header_bg1.png" /></div><div>邦人NAVI</div><div class="time">2022-12-10</div></div>
          </div>
          <div class="body_center_left_content_article1">
            <img src="@/assets/imgs/header_bg1.png" />
            <div class="title">科学的な慎重さと歪みの積極的な最適化と改善科学的な慎重さと科学的な慎重さと歪みの積極的な最適化と改善科</div>
            <div class="msg_time"><div class="img"><img src="@/assets/imgs/header_bg1.png" /></div><span>邦人NAVI</span><span class="time">2022-12-10</span></div>
          </div>
          <div class="body_center_left_content_article1">
            <img src="@/assets/imgs/header_bg1.png" />
            <div class="title">科学的な慎重さと歪みの積極的な最適化と改善科学的な慎重さと科学的な慎重さと歪みの積極的な最適化と改善科</div>
            <div class="msg_time"><div class="img"><img src="@/assets/imgs/header_bg1.png" /></div><span>邦人NAVI</span><span class="time">2022-12-10</span></div>
          </div>
          <div class="body_center_left_content_article1">
            <img src="@/assets/imgs/header_bg1.png" />
            <div class="title">科学的な慎重さと歪みの積極的な最適化と改善科学的な慎重さと科学的な慎重さと歪みの積極的な最適化と改善科</div>
            <div class="msg_time"><div class="img"><img src="@/assets/imgs/header_bg1.png" /></div><span>邦人NAVI</span><span class="time">2022-12-10</span></div>
          </div>
          <div class="body_center_left_content_article2">
            <div class="title">pk戦で悲喜こもごもの南米の両雄k戦で悲喜こもごもの南米の両雄こもごもの南米の両雄こもごもの両雄こもごも</div>
            <div class="img_list">
              <img src="@/assets/imgs/header_bg1.png" />
              <img src="@/assets/imgs/header_bg1.png" />
              <img src="@/assets/imgs/header_bg1.png" />
            </div>
            <div class="msg_time"><span>邦人NAVI</span><span class="time">2022-12-10</span></div>
          </div> -->
        </div>
      </div>
      <div class="body_center_right">
        <recommended-users></recommended-users>
        <recruit></recruit>
        <download></download>
        <disclaimers></disclaimers>
      </div>
    </div>
    <post-dialog v-if="detailsDialog" :detailsDialog.sync="detailsDialog" :postList="postList" :videoList="postList" :state="postState"></post-dialog>
  </div>
</template>

<script>
import recommendedUsers from '@/components/Right/recommendedUsers'
import Recruit from '@/components/Right/recruit'
import Download from '@/components/Right/download'
import Disclaimers from '@/components/Right/disclaimers'
import postDialog from '@/components/Dialog'
import * as json from '@/assets/js/json'
import { timeToStr } from '@/assets/js/util'
import deepCopy from 'json-deep-copy'
  export default {
    components: {
      recommendedUsers,
      Recruit,
      Download,
      Disclaimers,
      postDialog
    },
    data () {
      return {
        loading: false,
        num:{
          charmNum:0,
          followNum:0,
          followerNum: 0,
          trackCount: 0,
        },
        userInfo:{},
        list:[],
        page: 1,
        size: 10,
        friendState: 0,
        nextPageState: true,
        postState: 'post',
        detailsDialog: false,
        postList: []
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy(){
      window.removeEventListener('scroll', this.handleScroll)
    },
    created () {
      this.fetch()
    },
    methods: {
      fetch(){
        let userId = this.$route.query.id
        this.loading = true
        let option = {
          targetId :userId
        }
        json.post('/api/member/somebody_profile/detail', option).then((res) =>{
          this.num.charmNum = res.data.data.charmNum
          this.num.followNum = res.data.data.followNum
          this.num.followerNum = res.data.data.followerNum
          this.num.trackCount = res.data.data.trackCount
          this.userInfo = res.data.data.userInfo
        })
        this.getListFun()
      },
      getListFun(){
        let url = null
        let option = {
          size: this.size,
          current: this.page,
          targetId: this.$route.query.id,
        }
        this.loading = true
        if(this.friendState == 0){
          url = '/api/member/somebody_profile/all/trace'
        }else if(this.friendState == 1){
          url = '/api/member/somebody_profile/article/trace'
          option.articleType = 'COMMON'
        }else if(this.friendState == 2){
          url = '/api/member/somebody_profile/post/trace'
          option.type = 'VIDEO'
        }else if(this.friendState == 3){
          url = '/api/member/somebody_profile/post/trace'
          option.type = 'POST'
        }
        json.post(url, option).then((res) =>{
          this.nextPageState = true
          this.loading = false
          let list = [],mergedArray=null
          res.data.data.tracks.forEach(item => {
            item.data.trackType = item.trackType
            list.push(item.data)
          });
          if(this.page == 1){
            mergedArray = list
          }else{
            mergedArray = this.list.concat(list)
          }
          this.list = mergedArray
        })
      },
      followFun(){
        if(!this.$store.state.userInfo||!this.$store.state.token){
          this.$parent.loginResFun()
          return
        }
        let option = {
          targetId: this.userInfo.id
        }
        if(!this.userInfo.follow){
          json.post('/api/member/follow/follow', option).then((res) =>{
            if(res.data.success){
              this.userInfo.follow = true
            }
          })
        }else{
          json.post('/api/member/follow/unfollow', option).then((res) =>{
            if(res.data.success){
              this.userInfo.follow = false
            }
          })
        }
      },
      chatFun(){
        if(!this.$store.state.userInfo||!this.$store.state.token){
          this.$emit("loginResFun")
          return
        }
        let user = this.$store.state.userInfo
        let chatList = deepCopy(this.$store.state.chatList)
        if(this.$store.state.chatList===undefined){
          chatList = []
        }
        if (!chatList[user.id]) {
          chatList[user.id] = []
        }
        chatList[user.id].forEach((item,index) =>{
          if(item.id == this.userInfo.id){
            chatList[user.id].splice(index,1)
          }
        })
        chatList[user.id].unshift(this.userInfo)
        this.$store.commit('SET_UNREAD_CHAT_LIST', chatList)
        this.$router.push('chat')
      },
      timeToStr (val) {
        return timeToStr(val)
      },
      toArticleFun(item) {
        if(item.trackType == 'article'){
          this.$router.push('/article?articleId=' + item.id)
        }else{
          this.postList = item
          if(item.videoUrl){
            this.postState = 'video'
          }else{
            this.postState = 'post'
          }
          this.detailsDialog = true
        }
      },
      stateClickFun(num){
        this.page = 1
        this.friendState = num
        this.getListFun()
      },
      loginResFun(){
        this.$parent.loginResFun()
      },
      handleScroll() {
        const scrollTop = document.documentElement.scrollTop||document.body.scrollTop
        const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
        const scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight
        if (scrollTop + windowHeight >= scrollHeight-5) {
          if(this.nextPageState){
            this.nextPageState = false
            this.page ++
            this.getListFun()
          }
        }
      }
    }
  }
</script>
<style src="@/pages/index/friend/index.css" scoped>

</style>
